<template>
  <div>
    <div class="space-y-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Recipient Email</label>
        <input
          v-model="email"
          type="email"
          class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500"
          placeholder="Enter recipient email"
          @blur="touched = true"
        />
        <p v-if="showEmailError" class="mt-1 text-sm text-red-500">{{ emailErrorMessage }}</p>
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Message</label>
        <textarea
          v-model="message"
          rows="4"
          class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500"
          placeholder="Enter a message (optional)"
        ></textarea>
      </div>
      <div v-if="sendError" class="text-sm text-red-600">{{ sendError }}</div>
    </div>
    <div class="flex justify-end space-x-3 mt-4">
      <SecondaryButton :size="'md'" @click="cancel">Cancel</SecondaryButton>
      <PrimaryButton :size="'md'" :active="isValid && !isSending" :is-loading="isSending" @click="send">
        Send
      </PrimaryButton>
    </div>
  </div>
</template>

<script>
import PrimaryButton from '@/components/Molecules/PrimaryButton'
import SecondaryButton from '@/components/Molecules/SecondaryButton'
import isValidEmail from '@/utils/isValidEmail'

export default {
  name: 'GiftCardResendForm',
  components: { PrimaryButton, SecondaryButton },
  props: {
    code: {
      type: String,
      required: true
    },
    initialEmail: {
      type: String,
      default: ''
    },
    initialMessage: {
      type: String,
      default: ''
    }
  },
  emits: ['sent', 'cancel'],
  data() {
    return {
      email: this.initialEmail,
      message: this.initialMessage,
      touched: false,
      isSending: false,
      sendError: ''
    }
  },
  computed: {
    isValid() {
      return isValidEmail(this.email)
    },
    showEmailError() {
      return this.touched && !this.isValid
    },
    emailErrorMessage() {
      return 'Please enter a valid email address.'
    }
  },
  methods: {
    async send() {
      this.touched = true
      if (!this.isValid) return

      this.sendError = ''
      this.isSending = true
      try {
        await this.$store.dispatch('resendGiftCard', {
          code: this.code,
          email: this.email.trim(),
          message: this.message
        })
        this.$emit('sent', { code: this.code })
      } catch (error) {
        this.sendError = 'Failed to send gift card email. Please try again.'
      } finally {
        this.isSending = false
      }
    },
    cancel() {
      this.$emit('cancel')
    }
  }
}
</script>
